export enum PartInventoryPickingViewType {
  Requested = "requested",
  Allocated = "allocated",
  LeftOver = "leftover",
}
